import { rollupPlugin } from './index.ts';

export default rollupPlugin;
